module.exports = __webpack_public_path__ + "img/visa_logo.c9ddbc94.svg";